import React from "react";
import Grid from "@material-ui/core/Grid";
import { TextValidator } from 'react-material-ui-form-validator';
import Typography from "@material-ui/core/Typography";

import useGroupSetting from "Hooks/useGroupSetting";
import { message } from "constants/message";

export default function Retweet({ state, onChangeThold }) {
  const groupSetting = useGroupSetting();
  const messages = message();

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={2}>
          <Typography value="h6">条件</Typography>
        </Grid>
        <Grid item xs={10}>
          <Grid container>
            <Typography value="span">総RP数が</Typography>
            <TextValidator
              onChange={onChangeThold}
              value={ state.alert_params && state.alert_params.thold ? 
                state.alert_params.thold : 
                groupSetting.setData("thold", 100) }
              type="number"
              style={{ width: 185 }}
              InputProps={{ inputProps: { min: 100, style: { textAlign: 'right' }} }}
              validators={['required', 'minNumber:100']}
              errorMessages={[
                messages.validation.required, 
                ((messages.validation.minNumber).replace("$1", "総RP数")).replace("$2", "100")
              ]}
            />
            <Typography value="span">件以上の投稿を通知する</Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
